import { observable, action } from 'mobx';
import { Graph } from '@greycat/core';

export default class CodeCellStore {
  @observable private _source: string;
  @observable private _selected: boolean;
  @observable private _data: any = null;
  @observable private _error: string | null = null;
  @observable private _executed: boolean = false;

  constructor(private _graph: Graph, public category: string, source: string = '', selected: boolean = false) {
    this._source = source;
    this._selected = selected;
  }

  @action
  execute() {
    this._executed = true;
    return new Promise((resolve) => {
      const func = this._graph.newFunction().parse(this._source);
      const task = this._graph.newTask();
      task.onEnd((t) => resolve(t.toObject()));
      task.execute(func);
    }).then(this._executeSuccess, this._executeError);
  }

  @action.bound
  private _executeSuccess(o: any) {
    this._data = o;
    this._error = null;
  }

  @action.bound
  private _executeError() {
    this._data = null;
    this._error = 'Unable to execute this script';
  }

  get source(): string {
    return this._source;
  }

  set source(value: string) {
    this._source = value;
  }

  get data(): any {
    return this._data;
  }

  get error(): string | null {
    return this._error;
  }

  get executed(): boolean {
    return this._executed;
  }

  get selected(): boolean {
    return this._selected;
  }

  set selected(isSelected: boolean) {
    this._selected = isSelected;
  }
}
